export default defineAppConfig({
  ui: {
    colors: {
      primary: "lochmara",
      secondary: "elf-green",
      tertiary: "cedar",
    }
  }
});
